import { distanceInWordsToNow } from 'date-fns';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { TimeContext } from '../../../context/time';
import { Measurement } from '../../../lib/helpers/measurement';
import { MeasurementHelper } from '../../../lib/helpers/measurementHelper';
import { Card } from '../../ui';
import { variables } from '../../utils';
import BinaryLeft from './BinaryLeft';
import BinaryRight from './BinaryRight';
import FiverLeft from './FiverLeft';
import FiverRight from './FiverRight';
import IntegerLeft from './NumberLeft';
import IntegerRight from './NumberRight';
import TrafficLightLeft from './TrafficLightLeft';
import TrafficLightRight from './TrafficLightRight';

interface IChartCardProps {
  measurements: Measurement[];
  chartType: TrackerType;
  chartTitle: string;
}

export interface IChartCardLeftProps {
  helper: MeasurementHelper;
}

export interface IChartCardRightProps {
  helper: MeasurementHelper;
}

const LeftCol = styled.div.attrs({
  className: 'flex-none flex-ns flex-column justify-between w-third-ns pa3 pt4'
})`
  @media (max-width: ${variables.medium}px) {
    border-bottom: 1px solid ${variables.lightGray};
  }
  @media (min-width: ${variables.medium}px) {
    border-right: 1px solid ${variables.lightGray};
  }
`;

const RightCol = styled.div.attrs({
  className: 'w-two-thirds-ns pa3 pt4'
})``;

const ChartCard: React.FC<IChartCardProps> = ({ measurements, chartType, chartTitle }) => {
  const timeContext = useContext(TimeContext);
  const measurementHelper = new MeasurementHelper(measurements, timeContext.range);

  return (
    <Card className="mb2 flex-ns ph2-ns" data-testid={`chart-card-${chartTitle}`}>
      <LeftCol>
        <div>
          <h3 className="f5 fw6 mt0 mb1">{chartTitle}</h3>
          {measurementHelper.lastMeasurement && (
            <p className="f8 serif i mt0 mb3">
              tracked {distanceInWordsToNow(measurementHelper.lastMeasurement.notedAt)} ago
            </p>
          )}
        </div>
        <div>
          {chartType === 'FIVER' && <FiverLeft helper={measurementHelper} />}
          {chartType === 'INTEGER' && <IntegerLeft helper={measurementHelper} />}
          {chartType === 'TRAFFIC_LIGHT' && <TrafficLightLeft helper={measurementHelper} />}
          {chartType === 'BINARY' && <BinaryLeft helper={measurementHelper} />}
        </div>
      </LeftCol>

      <RightCol>
        {chartType === 'FIVER' && <FiverRight helper={measurementHelper} />}
        {chartType === 'TRAFFIC_LIGHT' && <TrafficLightRight helper={measurementHelper} />}
        {chartType === 'BINARY' && <BinaryRight helper={measurementHelper} />}
        {chartType === 'INTEGER' && <IntegerRight helper={measurementHelper} />}
      </RightCol>
    </Card>
  );
};

export default ChartCard;
